import KickoutLayout from "../shared/Layout/KickoutLayout";
import useGtmTracking from "../../../../hooks/useGtmTracking";

export default function ProducerKickout() {
    useGtmTracking("Onboarding:AgentKickout", "onboarding_agent_ineligible");

    return (
        <KickoutLayout
            header="Application Paused"
            icon="icon-alert"
        >
            <div className="container">
                <div className="margin-top row" style={{ marginTop: "60px" }}>
                    <div className="hidden-sm col-md-3">
                        <img src="images/pose.png" />
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <li className="alert-content" style={{ marginTop: "40px" }}>
                            <div className="h3">
                                Parent agency must complete application to continue.
                            </div>
                            <p>
                                Our records indicate that your parent agency has not completed their application.
                                Once your parent agency is approved,
                                we’ll notify you by email to complete your application. Your progress has been saved.
                            </p>
                        </li>
                    </div>
                </div>
            </div>
        </KickoutLayout>
    );
}